import { useMemo } from 'react'

import { Select, SimpleGrid } from '@mantine/core'
import { useGetList, useTranslate } from 'react-admin'
import { YoutubeChannel } from '../../../types/YoutubeChannel'
import { IPromotionCopySource } from '../../../types/components/VideoPromotion.type'
import { LXVideoSelect } from '../../LXVideoSelect'

type CopyVideoSelectionProps = {
  value: IPromotionCopySource | undefined
  onChange: (source: IPromotionCopySource) => void
}

export const CopyVideosSelection = ({ value, onChange }: CopyVideoSelectionProps) => {
  const t = useTranslate()
  const youtubeChannelId = value?.youtubeChannelId
  const videoId = value?.videoId

  const youtubeChannelsQuery = useGetList<YoutubeChannel>('youtubeChannels', {
    sort: { field: 'name', order: 'ASC' },
    pagination: { page: 1, perPage: 1000 },
  })
  const youtubeChannels = useMemo(
    () =>
      (youtubeChannelsQuery.data ?? []).map(b => ({
        value: b.id,
        label: b.name,
      })),
    [youtubeChannelsQuery.data],
  )

  return (
    <SimpleGrid cols={4} mt="xl" mb="sm">
      <Select
        label={t('_generics.youtubeChannel')}
        value={youtubeChannelId ?? null}
        data={youtubeChannels}
        onChange={ytId => onChange({ youtubeChannelId: ytId ?? undefined })}
        searchable
        clearable
        autoComplete="off"
        data-form-type="other"
        w="100%"
      />
      <LXVideoSelect
        label={t('pages.videoPromotion.sourceVideo')}
        youtubeChannelId={youtubeChannelId}
        value={videoId}
        onChange={video => onChange({ youtubeChannelId, videoId: video?.id })}
        clearable
      />
    </SimpleGrid>
  )
}
